module.exports = __webpack_public_path__ + "images/storage-basics/wte--moving-in.jpg";